import React from 'react';

export const AgentCardSkeleton: React.FC = () => {
    return (
        <div className="h-[272px] flex flex-col border border-border dark:border-border rounded-2xl p-4 animate-pulse">
            {/* Header */}
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                    <div className="w-9 h-9 bg-default dark:bg-hover rounded-full animate-pulse" />
                    <div className="h-5 w-24 bg-default dark:bg-hover rounded animate-pulse" />
                </div>
                <div className="w-6 h-6 bg-default dark:bg-hover rounded animate-pulse" />
            </div>

            {/* Role */}
            <div className="h-4 w-20 bg-default dark:bg-hover rounded animate-pulse mb-4" />

            {/* Info sections */}
            <div className="space-y-3 mb-4">
                <div className="flex items-center justify-between">
                    <div className="h-4 w-12 bg-default dark:bg-hover rounded animate-pulse" />
                    <div className="h-4 w-16 bg-default dark:bg-hover rounded animate-pulse" />
                </div>
                <div className="flex items-center justify-between">
                    <div className="h-4 w-16 bg-default dark:bg-hover rounded animate-pulse" />
                    <div className="h-4 w-20 bg-default dark:bg-hover rounded animate-pulse" />
                </div>
            </div>

            {/* Buttons */}
            <div className="mt-auto flex items-center gap-2">
                <div className="w-[162px] h-[38px] bg-default dark:bg-hover rounded animate-pulse" />
                <div className="flex-1 flex items-center gap-2">
                    <div className="flex-1 h-[38px] bg-default dark:bg-hover rounded animate-pulse" />
                    <div className="flex-1 h-[38px] bg-default dark:bg-hover rounded animate-pulse" />
                </div>
            </div>
        </div>
    );
};
